import { TranslatePipe } from "./translate.pipe";

export const Pipes = [
	TranslatePipe,
]
